export default __webpack_public_path__ + "images/e38c4601e6b87683b025366e4900f226-wrestling_small.webp";